module.exports = __webpack_public_path__ + "static/media/nodata.0c5f2150.svg";